var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 165,
    viewBox: "0 0 168 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.879 42.7108C151.431 42.7108 153.5 40.6421 153.5 38.0902C153.5 35.5383 151.431 33.4696 148.879 33.4696C146.328 33.4696 144.259 35.5383 144.259 38.0902C144.259 40.6421 146.328 42.7108 148.879 42.7108Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.259 27.7221C146.002 27.7221 147.414 26.3093 147.414 24.5665C147.414 22.8238 146.002 21.411 144.259 21.411C142.516 21.411 141.103 22.8238 141.103 24.5665C141.103 26.3093 142.516 27.7221 144.259 27.7221Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4602 38.0901C18.203 38.0901 19.6157 36.6773 19.6157 34.9346C19.6157 33.1918 18.203 31.7791 16.4602 31.7791C14.7175 31.7791 13.3047 33.1918 13.3047 34.9346C13.3047 36.6773 14.7175 38.0901 16.4602 38.0901Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.36026 107.512C12.5968 107.512 15.2205 104.888 15.2205 101.652C15.2205 98.415 12.5968 95.7913 9.36026 95.7913C6.12373 95.7913 3.5 98.415 3.5 101.652C3.5 104.888 6.12373 107.512 9.36026 107.512Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4634_1573)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.322 58.0297V119.045C145.322 119.296 145.322 119.422 145.322 119.674C145.196 123.196 143.56 126.216 141.044 128.354C138.906 130.241 136.012 131.499 132.867 131.499H34.3623C32.2236 131.499 30.2108 130.996 28.4495 129.99C27.6947 129.612 26.9399 129.109 26.3108 128.48C24.927 127.348 23.669 125.712 23.0399 123.951C22.5367 122.693 22.1593 121.309 22.1593 119.925V58.0297C22.1593 58.0297 27.3173 53.6266 34.7397 47.588C42.4138 41.172 52.4781 32.8689 61.2844 25.5722C66.3166 21.2949 65.8133 21.7981 73.6132 15.2563C79.526 10.2241 88.2065 10.2241 94.1193 15.2563C95.6289 16.5143 97.2644 18.024 98.774 19.282C102.045 21.9239 105.567 24.9432 109.342 28.0883C117.267 34.6301 125.948 41.9268 132.741 47.588C139.66 53.2492 144.693 57.5265 145.322 58.0297Z",
    fill: "#ADC8BD"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.741 47.4621V69.352L111.229 82.3098L104.813 86.2098L91.2257 94.387L84.8097 98.2869L82.042 99.9224L79.4002 98.2869L73.3615 94.387L60.4037 86.2098L54.3651 82.3098L34.4881 69.8552V47.5879C42.1621 41.1719 52.2264 32.8688 61.0327 25.5721L109.216 27.9624C117.267 34.63 125.948 41.8009 132.741 47.4621Z",
    fill: "#007954"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M128.464 30.1012V68.5973L108.838 80.297L103.051 83.8196L90.5967 91.1162L84.8098 94.6387L82.2937 96.0226L79.9034 94.6387L74.368 91.1162L62.5424 83.8196L57.007 80.297L38.8912 68.9747V30.1012C38.8912 26.0754 42.1621 22.8045 46.3137 22.8045H121.041C125.067 22.6787 128.464 26.0754 128.464 30.1012Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.6625 57.7782L81.7905 61.6781L144.441 57.7782L142.051 68.9748C142.051 68.9748 83.1743 99.671 83.5518 99.671C83.9292 99.671 22.7883 63.3136 22.7883 63.3136L22.6625 57.7782Z",
    fill: "url(#paint0_linear_4634_1573)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145.322 58.0297V119.674C145.196 123.196 143.56 126.216 141.044 128.354C138.906 130.241 136.012 131.499 132.867 131.499H34.3623C32.2236 131.499 30.2107 130.996 28.4495 129.99C27.6947 129.612 26.9398 129.109 26.3108 128.48C24.927 127.348 23.6689 125.712 23.0399 123.951C22.5367 122.693 22.1593 121.309 22.1593 119.925V119.799V58.0297L77.2615 92.5L82.042 95.5193L83.6775 94.5129L85.1872 93.6322L145.322 58.0297Z",
    fill: "#738DFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.17 128.354C139.031 130.241 136.138 131.499 132.993 131.499H34.3623C32.2236 131.499 30.2107 130.996 28.4495 129.99C27.6947 129.612 26.9398 129.109 26.3108 128.48C24.927 127.348 23.6689 125.712 23.0399 123.951C22.5367 122.693 22.1593 121.309 22.1593 119.925V119.799V58.0297L28.5753 61.9296L83.6775 94.5129L85.1871 95.3935L85.313 95.5193L134.754 124.706L141.17 128.354Z",
    fill: "url(#paint1_linear_4634_1573)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1872 93.5065V97.7839L28.4495 129.99C27.6947 129.612 26.9398 129.109 26.3108 128.48C24.927 127.348 23.6689 125.712 23.0399 123.951L78.268 91.2421L83.0485 94.2614L83.6775 94.513L85.1872 93.5065Z",
    fill: "url(#paint2_linear_4634_1573)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1593 58.0297L83.6775 94.5129",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M145.322 58.0297V119.674C145.196 123.196 143.56 126.216 141.044 128.354C138.906 130.241 136.012 131.499 132.867 131.499H34.3623C32.2236 131.499 30.2107 130.996 28.4495 129.99C27.6946 129.612 26.9398 129.109 26.3108 128.48L32.601 124.706L82.042 95.5193L83.6775 94.5129L85.1871 93.6322L138.78 61.8038L145.322 58.0297Z",
    fill: "url(#paint3_linear_4634_1573)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M145.322 58.0297L85.1871 93.5064L83.6775 94.5129L82.042 95.5193L26.3108 128.354",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.477 101.181H97.7676C97.0127 101.181 96.3837 100.552 96.3837 99.7967C96.3837 99.0419 97.0127 98.4128 97.7676 98.4128H130.477C131.231 98.4128 131.86 99.0419 131.86 99.7967C131.986 100.552 131.357 101.181 130.477 101.181Z",
    fill: "#0EB683"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.477 110.616H97.7676C97.0127 110.616 96.3837 109.987 96.3837 109.232C96.3837 108.477 97.0127 107.848 97.7676 107.848H130.477C131.231 107.848 131.86 108.477 131.86 109.232C131.986 109.987 131.357 110.616 130.477 110.616Z",
    fill: "#0EB683"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.27 130.241L141.296 128.229C141.17 128.354 141.17 128.354 141.044 128.48C141.044 128.48 141.044 128.48 140.918 128.48L137.27 130.241Z",
    fill: "#526DFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4634_1573",
    x: 0.159302,
    y: 0.482178,
    width: 167.162,
    height: 164.017,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4634_1573"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4634_1573",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4634_1573",
    x1: 83.4977,
    y1: 112.953,
    x2: 83.4977,
    y2: 60.6012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A90B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7AED2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4634_1573",
    x1: 81.6259,
    y1: 56.3302,
    x2: 81.6259,
    y2: 132.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF5F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4634_1573",
    x1: 57.6624,
    y1: 114.164,
    x2: 52.8384,
    y2: 107.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E4F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4634_1573",
    x1: 85.7774,
    y1: 56.3302,
    x2: 85.7774,
    y2: 132.291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF5F3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/messageIcon.c5f159bcdfc54c23fa1fcc290901d1dd.svg";
export { ForwardRef as ReactComponent };